import type { CandidateDocument } from '../page/types';
import type { Orientation } from '../types';

// Snake_case, as MarketOverviewSlotDocumentsController#index sends it through getRaw.
export interface SlotDocument {
  document_template_id: number;
  document_template_name: string;
  orientation: string | null;
  position: number | null;
  last_page: boolean;
}

export interface SlotDocumentsPayload {
  documents: SlotDocument[];
  candidates: CandidateDocument[];
}

export const MarketOverviewsTab = { Pages: 'pages', SlotSettings: 'slot_settings' } as const;

export type MarketOverviewsTab = (typeof MarketOverviewsTab)[keyof typeof MarketOverviewsTab];

// A Census market a page can be tagged with, from MarketOverviewPagesController#markets.
export interface MarketOption {
  code: string;
  title: string;
}

// Snake_case, as MarketOverviewPagesController#index sends it through getRaw.
export interface CollectionPage {
  id: number;
  name: string;
  orientation: Orientation;
  size_label: string | null;
  market_code: string | null;
  market_name: string | null;
  updated_at: string | null;
  // False for a page in the parent company's collection: it fills this company's slot, but only the parent
  // company can change it.
  owned: boolean;
}

// The collection's endpoints sit beside the Market Overviews page, which may carry a parent company user's
// company_id. Built from the Page Library's base so the list and page detail screens reach them too.
export const marketOverviewsUrls = (libraryBase: string) => {
  const base = `${libraryBase}/market_overviews`;

  return {
    collectionPages: `${base}/collection_pages`,
    collectionPage: (pageId: number) => `${base}/collection_pages/${pageId}`,
    markets: `${base}/markets`,
    slotDocuments: `${base}/slot_documents`,
  };
};
